import { useQuery } from 'react-query';

import { getUniqueTracesChart } from 'api/analitics/EncCharts/getUniqueTracesChart';

export const useGetUniqueTracesChart = (slug: string, start_date: string, end_date: string) => {
  return useQuery(['uniqueTracesChart', slug, start_date, end_date], () =>
    getUniqueTracesChart(slug, start_date, end_date),
  );
};
